// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"NewSessionSection_jumbotron__2qbrH"};